import { createContext, useContext, useMemo } from 'react'
import { collection } from 'firebase/firestore'
import { useCollection } from '@kage1020/react-firebase-hooks/firestore'
import { db } from '../firebase'
import { useAuth } from './AuthContext'
import { DEFAULT_EVENT_TYPES, DEFAULT_TYPE } from '../constants/eventTypes'

const EventTypesContext = createContext(null)

// eslint-disable-next-line react-refresh/only-export-components
export function useEventTypes() {
  return useContext(EventTypesContext)
}

export function EventTypesProvider({ children }) {
  const { user } = useAuth()
  // Only signed-in users may read eventTypes (rules); pass null otherwise so
  // the hook never issues an unauthorized read.
  const [snapshot, loading] = useCollection(user ? collection(db, 'eventTypes') : null)

  const value = useMemo(() => {
    const typesById = { ...DEFAULT_EVENT_TYPES }
    if (snapshot) {
      snapshot.docs.forEach((d) => {
        typesById[d.id] = { ...(typesById[d.id] || {}), ...d.data() }
      })
    }
    const typesList = Object.entries(typesById)
      .map(([id, cfg]) => ({ id, ...cfg }))
      .sort((a, b) => (a.label?.en || a.id).localeCompare(b.label?.en || b.id))
    const getTypeConfig = (typeId) =>
      typesById[typeId] || DEFAULT_EVENT_TYPES[typeId] || DEFAULT_EVENT_TYPES[DEFAULT_TYPE]
    return { typesById, typesList, getTypeConfig, loading }
  }, [snapshot, loading])

  return (
    <EventTypesContext.Provider value={value}>
      {children}
    </EventTypesContext.Provider>
  )
}
